import _classCallCheck from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * DevExtreme (esm/renovation/ui/common/ink_ripple.js)
 * Version: 22.1.5
 * Build date: Fri Sep 02 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _extends from "@babel/runtime/helpers/esm/extends";
var _excluded = ["config"];
import { createVNode, normalizeProps } from "inferno";
import { BaseInfernoComponent } from "@devextreme/runtime/inferno";
import { initConfig, showWave as _showWave, hideWave as _hideWave } from "../../../ui/widget/utils.ink_ripple";
export var viewFunction = function viewFunction(model) {
  return normalizeProps(createVNode(1, "div", "dx-inkripple", null, 1, _extends({}, model.restAttributes)));
};
export var InkRippleProps = {
  config: Object.freeze({})
};
export var InkRipple =
/*#__PURE__*/
function (_BaseInfernoComponent) {
  _inherits(InkRipple, _BaseInfernoComponent);

  function InkRipple(props) {
    var _this;

    _classCallCheck(this, InkRipple);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InkRipple).call(this, props));
    _this.state = {};
    _this.__getterCache = {};
    _this.hideWave = _this.hideWave.bind(_assertThisInitialized(_this));
    _this.showWave = _this.showWave.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(InkRipple, [{
    key: "hideWave",
    value: function hideWave(opts) {
      _hideWave(this.getConfig, opts);
    }
  }, {
    key: "showWave",
    value: function showWave(opts) {
      _showWave(this.getConfig, opts);
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate(nextProps, nextState, context) {
      if (this.props.config !== nextProps.config) {
        this.__getterCache.getConfig = void 0;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      return viewFunction({
        props: _extends({}, props),
        getConfig: this.getConfig,
        restAttributes: this.restAttributes
      });
    }
  }, {
    key: "getConfig",
    get: function get() {
      var _this2 = this;

      if (void 0 !== this.__getterCache.getConfig) {
        return this.__getterCache.getConfig;
      }

      return this.__getterCache.getConfig = function () {
        var config = _this2.props.config;
        return initConfig(config);
      }();
    }
  }, {
    key: "restAttributes",
    get: function get() {
      var _this$props = this.props,
          restProps = _objectWithoutPropertiesLoose(_this$props, _excluded);

      return restProps;
    }
  }]);

  return InkRipple;
}(BaseInfernoComponent);
InkRipple.defaultProps = InkRippleProps;